/* dp-globaal.js — eigen scripts voor dailyplay.nl (Dailyplay-audit 24-09-2026).

   Rad-popup van Pop Convert op mobiel (herstel 24-09, audit ch-01/ch-02/ch-03, klachten Damian 24-09):
   de popup is een app in een eigen shadow root, dus CSS uit het thema komt er niet in. Dit script zet er
   een eigen <style> in en repareert drie teksten. Wat het doet:
   - telefoon (max 640 px breed): de productfoto op de invulstap weg, zodat e-mailveld en knop in beeld
     staan (iPhone 13: knop stond op 729-768 bij een scherm van 664); lage schermen schalen de kaart iets;
   - onder de knop één regel hoe je draait (klanten wisten het niet);
   - "Je meld je aan" wordt "Je meldt je aan", het veld vraagt om een e-mailadres (toetsenbord met @).
   Het rad zelf, de vakken en de kortingen blijven van de app. Verdwijnt de app, dan doet dit niets. */
(function () {
  'use strict';
  var CSS = [
    '@media (max-width: 640px) {',
    '  .blocks-renderer:has(form.form-block) .image-block { display: none !important; }',
    '  .blocks-renderer:has(form.form-block) .block-content-image { display: none !important; }',
    '  .blocks-renderer { padding-top: 6px !important; padding-bottom: 12px !important; }',
    '  #pc-modal-close-button, #pc-main-close-button { width: 44px !important; height: 44px !important; display: flex !important; align-items: center; justify-content: center; }',
    '}',
    '@media (max-width: 640px) and (max-height: 620px) {',
    '  .modal-card.wheel { zoom: 0.84; }',
    '}',
    'form.form-block::after { content: "Vul je e-mail in en tik op de knop, dan draait het rad."; display: block; margin-top: 8px; font-size: 12px; line-height: 1.35; text-align: center; opacity: .8; }'
  ].join('\n');
  var TEKSTEN = [
    ['Je meld je aan voor de nieuwsbrief waarin je leuke blogs en exclusieve kortingen ontvangt.', 'Je meldt je aan voor de nieuwsbrief met tips en exclusieve kortingen.'],
    ['Je meld je aan', 'Je meldt je aan']
  ];
  function repareer(root) {
    if (!root.getElementById('dp-pop-herstel')) {
      var st = document.createElement('style');
      st.id = 'dp-pop-herstel';
      st.textContent = CSS;
      root.appendChild(st);
    }
    var inputs = root.querySelectorAll('input.form-block-input');
    for (var i = 0; i < inputs.length; i++) {
      var inp = inputs[i];
      if (inp.getAttribute('placeholder') === 'Vul email in') inp.setAttribute('placeholder', 'Vul je e-mailadres in');
      if (inp.getAttribute('inputmode') !== 'email') { inp.setAttribute('inputmode', 'email'); inp.setAttribute('autocomplete', 'email'); inp.setAttribute('autocapitalize', 'off'); inp.setAttribute('spellcheck', 'false'); }
    }
    var spans = root.querySelectorAll('.text-block span, .text-block p');
    for (var j = 0; j < spans.length; j++) {
      var el = spans[j];
      if (el.children.length) continue;
      for (var k = 0; k < TEKSTEN.length; k++) {
        if (el.textContent.indexOf(TEKSTEN[k][0]) >= 0) { el.textContent = el.textContent.replace(TEKSTEN[k][0], TEKSTEN[k][1]); break; }
      }
    }
  }
  var bewaakt = null, wacht = null;
  function kijk() {
    var host = document.getElementById('pop-convert-app');
    var root = host && host.shadowRoot;
    if (!root) return;
    repareer(root);
    if (bewaakt !== root) {
      bewaakt = root;
      new MutationObserver(function () {
        if (wacht) return;
        wacht = setTimeout(function () { wacht = null; repareer(root); }, 60);
      }).observe(root, { childList: true, subtree: true, characterData: true });
    }
  }
  // De app zet zijn host-element later in de body; tot die er is kijken we mee op de body.
  var poging = 0;
  var tik = setInterval(function () {
    poging++;
    kijk();
    if (bewaakt || poging > 120) clearInterval(tik);
  }, 500);
})();
